import { useTranslations } from 'core/hooks'
import { t } from './Translation'

const intervals = [
  ['year', 31536000],
  ['month', 2592000],
  ['week', 604800],
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60],
  ['second', 1],
]

const calculateTime = timestamp => {
  const seconds = Math.max(Math.floor(Date.now() / 1000 - timestamp), 1) // JS uses ms while unix uses seconds
  const [unit, period] = intervals.find(([, value]) => seconds / value >= 1)
  const value = Math.floor(seconds / period)
  return [value, unit]
}

export const Time = ({ since }) => {
  const { time } = useTranslations()
  const [value, unit] = calculateTime(since)

  if (unit === 'second') {
    return time.justNow
  }
  if (time.rtf) {
    return time.rtf.format(-value, unit)
  }
  if (unit === 'day' && value === 1) {
    return time.yesterday
  }
  return `${value} ${time[unit + (value > 1 ? 's' : '')]} ${time.ago}`
}

export const Age = ({ user, yearsOld }) => {
  const delta = Date.now() - new Date(user.birthday).getTime()
  const years = new Date(delta).getUTCFullYear() - 1970

  return yearsOld ? `${years} ${t('yearsOld')}` : years
}

export default Time